import { render, staticRenderFns } from "./integral-goods-group-form.vue?vue&type=template&id=63c07be6&"
import script from "./integral-goods-group-form.vue?vue&type=script&lang=js&"
export * from "./integral-goods-group-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports